import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=1980a64c&scoped=true"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSignUp.vue?vue&type=style&index=0&id=1980a64c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980a64c",
  null
  
)

export default component.exports